import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  width: ${props => props.width || '100%'};
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
`;

const Label = styled.label`
  font-size: 13px;
  color: var(--text-secondary);
  margin-bottom: 6px;
  font-weight: 500;
`;

const SelectWrap = styled.div`
  position: relative;
  
  &::after {
    content: '▼';
    position: absolute;
    right: 14px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 10px;
    color: var(--text-muted);
    pointer-events: none;
  }
`;

const StyledSelect = styled.select`
  width: 100%;
  padding: 12px 16px;
  border-radius: 8px;
  background: var(--glass-1);
  border: 1px solid var(--glass-border);
  color: var(--text-primary);
  appearance: none;
  outline: none;
  font-family: inherit;
  font-size: 14px;
  backdrop-filter: blur(8px);
  cursor: pointer;

  &:focus {
    border-color: var(--accent);
    box-shadow: 0 0 0 2px rgba(6,182,212,0.2);
  }

  option {
    background: #0b1120;
    color: #fff;
  }
`;

const SelectInputWidget = ({ node }) => {
  const labelText = node.content?.label || 'Option wählen';
  const optionsRaw = node.content?.options || "Option A,Option B,Option C";
  const options = optionsRaw.split(',').map(o => o.trim()).filter(Boolean);

  return (
    <Wrapper width={node.style?.desktop?.width || '100%'}>
      {labelText && <Label>{labelText}</Label>}
      <SelectWrap>
        <StyledSelect>
          {options.map((opt, i) => (
            <option key={i} value={opt}>{opt}</option>
          ))}
        </StyledSelect>
      </SelectWrap>
    </Wrapper>
  );
};

registry.register('select_input', {
  label: 'Select Dropdown',
  icon: '🔽',
  category: 'forms',
  defaultContent: {
    label: 'Ihre Auswahl',
    options: 'Option 1,Option 2,Option 3'
  },
  defaultStyle: {
    desktop: { width: '100%' }
  },
  render: SelectInputWidget,
  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Select Daten',
          fields: [
            { name: 'content.label', label: 'Label Text', type: 'text' },
            { name: 'content.options', label: 'Optionen (Kommasepariert)', type: 'textarea' }
          ]
        }
      ]
    },
    {
      tab: 'style',
      groups: [
        {
          title: 'Layout',
          fields: [
            { name: 'style.desktop.width', label: 'Breite (z.B. 100%, 300px)', type: 'text' }
          ]
        }
      ]
    }
  ]
});
